// 字典值

export default {
  // 食谱类型
  RECIPE_TYPE: {
    SOUP: "汤机",
    AIR_FRYER: "空炸",
    SOUP_AND_AIR: "汤机+空炸",
    STAND_MIXER: "厨师机",
    SOUP_AND_STAND_MIXER: "汤机+厨师机",
    OVEN: "烤箱",
  },

  // 难易水平
  DIFFICULTY_LEVEL: {
    easy: "容易",
    medium: "中等",
    hard: "困难",
  },

}

